module.exports = __webpack_public_path__ + "img/top-word-12.f5717c16.png";